import React from 'react';
import {reportGridEvent} from "../../../Analytics/googleGridAdapter";
import groupGridSlice from "../../../ReduxStore/GroupGrid/groupGridSlice";
import {useDispatch} from "react-redux";
import {getClasses} from "../../styles";
import clsx from 'clsx';
import {useCartConfig} from "../../../contexts/CartConfigContext";
import {isTruthy} from "../../../Utility/logic";

// 2023-11 cleaned up, brand sort fixed, Relevance label added
// 2022-07 updated for groupGridSlice
const SORT_KEYS = [
  "default", "rel", "new", "price", "price_reverse",
  "rating", "name", "brand", "pop",
];

const labels = {
  default: "Sort By", // probably Relevance
  rel: "Relevance",
  new: "Newest",
  price: "Price: Low to High",
  price_reverse: "Price: High to Low",
  rating: "Customer Rating",
  name: "Alphabetical",
  brand: "Brand",
  pop: "Top Sellers"
};

export default function GridSortControl({
  gridId,
  gridState = {},
  gridItems,
  className
}) {
  const {sort = 'default', previousSort = null} = gridState;
  const dispatch = useDispatch();

  const cartConfig = useCartConfig();

  // 2026-06: remove price/price_reverse from the list of sort keys
  // when pricing is hidden (Carlyle)
  const hidePricing = isTruthy(cartConfig?.hidePricing);

  const handleChange = (e) => {
    let newSort = e?.target?.value;

    if (!newSort || (newSort === 'default'))
      newSort = "rel";

    const payload = {
      gridId,
      gridState: {
        sort: newSort,
        previousSort: sort,
        sortTouched: true,
        // currentPage: 1,
      }
    };

    dispatch(groupGridSlice.actions.updateGridState(payload));

    reportGridEvent({
      eventType: 'product_grid_sort',
      gridItems: gridItems,
      gridState: gridState,
      params: {sort_order: newSort}
    });
  }

  // used only for the widget, so we know to show "Sort by" or "Relevance"
  const widgetValue = gridState.sortTouched ? sort : "default";

  const selectClasses = getClasses('gridControlSelect');

  const keysEnabled = hidePricing ? SORT_KEYS.filter(k => k !== 'price' && k !== 'price_reverse') : SORT_KEYS;

  return (
    <div className={clsx(className)}>
      {' '}
      <select className={clsx(selectClasses)}
        name="sort" value={widgetValue} onChange={handleChange}>
        {keysEnabled.map((k) =>
          <option key={k} value={k}>{labels[k] || k}</option>)}
      </select>
    </div>
  );

}
